export const LabourColumns = [
  {
    id: "actions",
    title: "Actions",
  },
  {
    id: "name",
    title: "Name",
  },
  {
    id: "contact",
    title: "Contact",
  },
  {
    id: "address",
    title: "Address",
  },
  {
    id: "salary",
    title: "Sallary",
  },
];
